import '../../../vendors/typeahead.jquery.js';

import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

import $ from 'jquery';

@Component({
  selector: 'input-suggestion',
  templateUrl: './input-suggestion.component.html',
  styleUrls: ['./input-suggestion.component.scss']
})
export class InputSuggestionComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  // tslint:disable:no-input-rename
  // tslint:disable:no-output-rename
  @Input('id')
  inputId = 'input-suggestion';

  @Input('value')
  inputValue = '';

  @Input('placeholder')
  inputPlaceholder = 'Search...';

  @Input('minSize')
  textInputMinimumSize = 3;

  @Input('data')
  suggestionData = [];

  @Output('onFetchSuggestion')
  onGetSuggestionOutput: EventEmitter<String> = new EventEmitter();

  @Output('onInputSelected')
  onInputSelectedOutput: EventEmitter<any> = new EventEmitter();

  @Output('onInputCleared')
  onClearedOutput: EventEmitter<any> = new EventEmitter();

  private $typeaheadElement;
  private textValue = '';
  private syncResult: any;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    changes.suggestionData && changes.suggestionData.currentValue &&
    this.onSuggestionChanged(changes.suggestionData.currentValue);

    changes.inputValue && changes.inputValue.currentValue &&
    (this.textValue = changes.inputValue.currentValue);
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.$typeaheadElement && this.$typeaheadElement.typeahead('destroy');
  }

  ngAfterViewInit() {
    this.$typeaheadElement = $('#' + this.inputId + '-control');
    this.setupTypeahead();
    this.setupInputKeyupEvent();
    this.setupTypeaheadSelectAllText();
  }

  setupTypeahead() {
    this.$typeaheadElement.typeahead({
      highlight: true,
      hint: false,
      minLength: this.textInputMinimumSize,
      classNames: { menu: 'input-suggestion-menu' }
    }, {
      name: 'suggestion-' + this.inputId,
      source: this.setupTypeaheadSource(),
    })
    .bind('typeahead:selected', this.setupTypeaheadSelected());
  }

  setupTypeaheadSource() {
    return (query, syncResult, asyncResult) => {
      this.onGetSuggestionOutput.emit(query);
      this.syncResult = asyncResult;
    };
  }

  setupTypeaheadSelected() {
    return (event, datum, dataset) => {
      this.onItemSelected(datum);
    };
  }

  setupTypeaheadSelectAllText() {
    const $element = this.$typeaheadElement;
    $element.on('click', () => {
      $element && $element.select();
    });
  }

  setupInputKeyupEvent() {
    const $element = this.$typeaheadElement;
    $element.on('keyup', (event) => {
      const isPressEnter      = event.keyCode === 13;
      const isPressEsc        = event.keyCode === 27;

      // press enter button => submit to search
      if (isPressEnter) {
        this.onInputSelectedOutput.emit(this.textValue);
        $element.blur();
      }

      // press esc button => clear text input
      if (isPressEsc) {
        this.onClearButtonClicked(undefined);
        $element.blur();
      }
    });
  }

  onSuggestionChanged(data) {
    this.syncResult && this.syncResult(data);
  }

  onItemSelected(data) {
    this.onInputSelectedOutput.emit(data);
    this.$typeaheadElement && this.$typeaheadElement.blur();
  }

  onClearButtonClicked(data) {
    this.onClearedOutput.emit();
    this.$typeaheadElement.typeahead('val', '');
    this.textValue = '';
    this.suggestionData = [];
    this.onSuggestionChanged(this.suggestionData);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/input-suggestion/input-suggestion.component.ts